import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import './ErrorPage.scss'

const ForbiddenPage = () => {
  const { t } = useTranslation('common')

  return (
    <div className="error-page">
      <div className="error-page__card">
        <div className="error-page__code">403</div>
        <h1 className="error-page__title">{t('errors.accessDenied')}</h1>
        <p className="error-page__message">{t('errors.noPermission')}</p>
        <Link to="/" className="error-page__button">
          {t('errors.goHome')}
        </Link>
      </div>
    </div>
  )
}

export default ForbiddenPage
